<!-- 质检报告 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div>
                <div class="mt-24 mb-24" v-if="name_id == 1">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <FormItem label="长宽比例">
                            <Select v-model="newFormData.content.height_id" clearable filterable placeholder="请输入长宽比例">
                                <Option v-for="item in heightList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <div class="form-title">质检报告</div>
                        <FormItem label="名称颜色">
                            <ColorPicker v-model="newFormData.content.title_color"/>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input v-model="newFormData.content.title_size" placeholder="文字大小"></Input>
                        </FormItem>
                        <FormItem label="背景颜色">
                            <ColorPicker v-model="newFormData.content.title_bg_color"/>
                        </FormItem>
                        <div class="form-title">质检名称</div>
                        <FormItem label="内容颜色">
                            <ColorPicker v-model="newFormData.content.text_color"/>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input v-model="newFormData.content.text_size" placeholder="文字大小"></Input>
                        </FormItem>
                        <FormItem label="背景颜色">
                            <ColorPicker v-model="newFormData.content.text_bg_color"/>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            name_id: "1",
            heightList: [
                { id: 1, name: "1：1" },
                { id: 2, name: "2：1" },
                { id: 3, name: "4：3" },
                { id: 4, name: "3：4" },
                { id: 5, name: "1：2" },
            ],
        };
    },
    mounted() {
    },
    methods: {
        selectName(name) {
            this.name_id = name;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
</style>